import React, {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Pagination} from "swiper/modules";
import image from "../../assets/images/home/slider/1.jpg";
import axios from "axios";
import {baseUrl} from "../../api/network";
import * as AppStore from "../../redux/app";
import {toast} from "react-toastify";
import toastOptions from "../../data/ToastOptions";
import {useShallowPickSelector} from "../../redux";
import SliderItem from "./sliderItem";

const Slider = () => {
    const [sliderData, setSliderData] = useState([]);

    useEffect(() => {
        getSliderDataFn();
    }, []);

    const getSliderDataFn = () => {
        const headers = {
            'Content-Type': 'application/json',
        }

        axios.get(`${baseUrl}/slider`,{headers})
            .then(response => {
                if (response.data.status === '1') {
                    setSliderData(response.data.data)
                } else {
                    toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 11});
                }
            })
            .catch(() => {
                toast.error('Something went wrong. Please try again.', {...toastOptions, toastId: 12});
            })
    }

    return (
        <Swiper
            autoHeight={true}
            spaceBetween={10}
            slidesPerView={1}
            freeMode={true}
            autoplay={{
                delay: 4000,
                disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            modules={[Autoplay, Pagination]}
            className="swiper"
        >
            {sliderData && sliderData?.length > 0 && sliderData.map(item => {
                return (
                    <SwiperSlide key={Math.random().toString()}>
                        <SliderItem item={item} />
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
}

export default Slider;
